export enum Permission {
  RetailerCollections = 'retailer-collections',
  RetailerCollectionsRetailerCollectionsV2 = 'retailer_collections_retailer_collections.view',
  RetailerCollectionsV2Modify = 'retailer_collections.modify',
  RetailerCollectionsGlobalModify = 'retailer_collections_global.modify',
  Admin = 'admin_panel.legacy_permission',
  Flyers = 'flyers.view',
  FlyersModify = 'flyers.modify',
  FlyersAdmin = 'flyers_admin.view',
  CatalogProductsView = 'catalog_products.view',
  StoreConfigsView = 'store_configs.view',
  RetailerCollectionsView = 'retailer_collections.view',
}
